import { Routes, BrowserRouter as Router, Route } from 'react-router-dom';

// routes
import { publicRoutes, authProtectedRoutes } from './routes/app/routes';
import Authmiddleware from './routes/app/Authmiddleware';

import './index.css';
import { Suspense } from 'react';
import Page404 from './pages/Page404';
import './i18n';
import Providers from './Providers';
import ErrorPage from './pages/ErrorPage';

export default function App() {
  return (
    <Providers>
      <Suspense fallback={true}>
        <Router>
          <Routes>
            {publicRoutes.map((route, idx) => (
              <Route
                path={route.path}
                element={
                  <Authmiddleware
                    component={route.component}
                    isAuthProtected={false}
                    type={route.type}
                  />
                }
                key={idx}
                errorElement={<ErrorPage />}
              />
            ))}

            {authProtectedRoutes.map((route, idx) => (
              <Route
                path={route.path}
                element={
                  <Authmiddleware
                    component={route.component}
                    isAuthProtected={true}
                    type={route.type}
                  />
                }
                key={idx}
                errorElement={<ErrorPage />}
              />
            ))}
            <Route path="*" element={<Page404 />} />
          </Routes>
        </Router>
      </Suspense>
    </Providers>
  );
}
